import {
  DefaultDialogsContainerNames,
  TextLibrary,
  CinnamonActionNames,
  CinnamonVariables,
  TemplateActionNames,
} from '../consts/defaultConfigValues/defaultConstants'

/**
 * Props for one of the dialogs the place-order chain opens, by name.
 *
 * ⚠️ **`CONFIRM_ORDER` is not a validator, and pushing it into the validator
 * list would show it first.** `useLoadDialogValidations` drains that list with
 * `pop()`, so the last entry opens first — the confirm dialog reaches this
 * function from that hook's `else` branch instead, once every validator has
 * been accepted. `validationsList` in `hooks/usePlaceOrder.ts` is the list of
 * names that may legitimately appear in `defaultSlice.validators`.
 */

const getValidatorDialogsProps = (validator: string) => {
  switch (validator) {
    case DefaultDialogsContainerNames.VALIDATE_ALCOHOL: {
      return {
        show: true,
        container: DefaultDialogsContainerNames.VALIDATE_ALCOHOL,
        title: { value: '' },
        id: 'alcoholdialog-0001',
        icon: {
          name: 'MdWarningAmber',
        },
        message: {
          value:
            '{{default.sessionData.configuration.checkoutRules.cartConditionPendingUserValidation.message}}',
        },
        buttons: [
          {
            label: TextLibrary.ACTIONS_ACCEPT,
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CLOSE_DIALOG,
                },
                {
                  name: CinnamonActionNames.LOAD_DIALOGS_VALIDATIONS,
                  args: {
                    validators: '{{default.validators}}',
                  },
                },
              ],
            },
          },
          {
            label: TextLibrary.ACTIONS_CANCEL,
            color: 'inherit',
            variant: 'outlined',
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CLOSE_DIALOG,
                  args: {
                    container: DefaultDialogsContainerNames.VALIDATE_ALCOHOL,
                    rejected: true,
                  },
                },
                {
                  name: TemplateActionNames.PLACE_ORDER_CLEAR,
                },
              ],
            },
          },
        ],
      }
    }
    case DefaultDialogsContainerNames.VALIDATE_RETURNABLE: {
      return {
        show: true,
        title: { value: '' },
        id: 'returnabledialog-0002',
        container: DefaultDialogsContainerNames.VALIDATE_RETURNABLE,
        icon: {
          name: 'MdWarningAmber',
        },
        message: {
          value:
            '{{default.sessionData.configuration.checkoutRules.cartWarningCheckReturnables.message}}',
        },
        buttons: [
          {
            label: TextLibrary.ACTIONS_ACCEPT,
            actions: {
              cinnamonActions: [
                {
                  name: 'closeDialog',
                },
                {
                  name: CinnamonActionNames.LOAD_DIALOGS_VALIDATIONS,
                  args: {
                    validators: '{{default.validators}}',
                  },
                },
              ],
            },
          },
          {
            label: TextLibrary.ACTIONS_CANCEL,
            color: 'inherit',
            variant: 'outlined',
            actions: {
              cinnamonActions: [
                {
                  name: 'closeDialog',
                  args: {
                    rejected: true,
                    container: DefaultDialogsContainerNames.VALIDATE_RETURNABLE,
                  },
                },
                {
                  name: TemplateActionNames.PLACE_ORDER_CLEAR,
                },
              ],
            },
          },
        ],
      }
    }
    case DefaultDialogsContainerNames.CONFIRM_ORDER: {
      return {
        show: true,
        id: 'confirmOrderdialog-0003',
        container: DefaultDialogsContainerNames.CONFIRM_ORDER,
        icon: {
          name: 'MdCheck',
        },
        title: {
          value: TextLibrary.CART_CONFIRM_TITLE,
        },
        message: {
          value: TextLibrary.CART_CONFIRM_MESSAGE,
        },
        buttons: [
          {
            label: TextLibrary.ACTIONS_YES,
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CREATE_ORDER,
                  args: {
                    sessionId: CinnamonVariables.SESSION_ID,
                    storeFrontName: CinnamonVariables.STOREFRONT_NAME,
                    phone: CinnamonVariables.WORKFLOW_ID,
                    cart: CinnamonVariables.CART,
                    session: CinnamonVariables.SESSION_DATA,
                  },
                },
                {
                  name: CinnamonActionNames.CLOSE_DIALOG,
                },
                {
                  name: TemplateActionNames.PLACE_ORDER_FLOW_NEXT,
                },
              ],
            },
          },
          {
            label: TextLibrary.ACTIONS_CANCEL,
            color: 'inherit',
            variant: 'outlined',
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CLOSE_DIALOG,
                  args: {
                    rejected: true,
                    container: DefaultDialogsContainerNames.CONFIRM_ORDER,
                  },
                },
                {
                  name: TemplateActionNames.PLACE_ORDER_CLEAR,
                },
              ],
            },
          },
        ],
      }
    }
    default: {
      return {
        show: false,
        title: { value: '' },
        icon: {
          name: '',
        },
        message: {
          value: '',
        },
        buttons: [],
      }
    }
  }
}

export default getValidatorDialogsProps
